<nav class="navbar navbar-expand-lg bg-primary navbar-transparent navbar-absolute" color-on-scroll="500">
    <div class="container">
        <div class="navbar-wrapper">
            <a class="navbar-brand" href="/login">{{titulo}}</a>
        </div>
        <!-- <button mat-button class="navbar-toggler" type="button">
            <span class="sr-only">Toggle navigation</span>
            <span class="navbar-toggler-icon icon-bar"></span>
            <span class="navbar-toggler-icon icon-bar"></span>
            <span class="navbar-toggler-icon icon-bar"></span>
        </button> -->
    </div>
</nav>

<div class="full-page login-page" filter-color="black" data-image="assets/img/login.jpeg">
    <div class="full-page-background" style="background-image: url('assets/img/login.jpeg') "></div>
    <ng-content></ng-content>
    <app-footer></app-footer>
</div>
